<template>
  <div class="page-container">
    <!-- 搜索表单 -->
    <div class="search-form">
      <el-form :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="关键词">
          <el-input
            v-model="searchForm.keyword"
            placeholder="请输入群名称"
            clearable
            style="width: 200px"
          />
        </el-form-item>

        <!-- <el-form-item label="状态">
          <el-select
            v-model="searchForm.status"
            placeholder="请选择状态"
            clearable
          >
            <el-option label="正常" :value="0" />
            <el-option label="禁用" :value="1" />
          </el-select>
        </el-form-item> -->
        <el-form-item>
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="resetSearch">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 工具栏 -->
    <div class="toolbar">
      <div class="toolbar-left">
        <el-button type="primary" icon="el-icon-plus" @click="handleCreate">
          新增群组
        </el-button>
      </div>
      <div class="toolbar-right">
        <el-button icon="el-icon-refresh" @click="loadData">刷新</el-button>
      </div>
    </div>

    <!-- 表格 -->
    <el-table
      v-loading="loading"
      :data="tableData"
      :max-height="tableMaxHeight"
      style="width: 100%"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55" />
      <el-table-column prop="id" label="群组ID" width="120" />
      <el-table-column prop="name" label="群名称" width="150">
      </el-table-column>

      <el-table-column prop="isMuted" label="是否禁言" width="80">
        <template slot-scope="scope">
          {{ scope.row.isMuted ? "是" : "否" }}
        </template>
      </el-table-column>

      <el-table-column prop="notice" label="群公告" width="150">
        <template slot-scope="scope">
          {{ scope.row.notice }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="200" fixed="right">
        <template slot-scope="scope">
          <div class="table-actions">
            <el-button size="mini" type="primary" @click="handleEdit(scope.row)"
              >编辑</el-button
            >
            <el-dropdown
              @command="(command) => handleCommand(command, scope.row)"
            >
              <el-button size="mini">
                更多<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="delete" divided
                  >删除</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <!-- <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pagination.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total"
      />
    </div> -->

    <!-- 新增/编辑对话框 -->
    <group-form
      :visible.sync="formVisible"
      :group-data="currentGroup"
      @success="handleFormSuccess"
    />

    <!-- 详情对话框 -->
    <group-detail :visible.sync="detailVisible" :group-data="currentGroup" />

    <!-- 成员管理对话框 -->
    <group-members :visible.sync="membersVisible" :group-data="currentGroup" />
  </div>
</template>

<script>
import { getGroupList, deleteGroup, changeGroupStatus } from "@/api/group";
import GroupForm from "./components/GroupForm";
import GroupDetail from "./components/GroupDetail";
import GroupMembers from "./components/GroupMembers";

export default {
  name: "GroupList",
  components: {
    GroupForm,
    GroupDetail,
    GroupMembers,
  },
  data() {
    return {
      loading: false,
      tableData: [],
      tableMaxHeight: 400,
      selectedRows: [],
      searchForm: {
        keyword: "",
        groupType: null,
        status: null,
      },
      pagination: {
        page: 1,
        size: 20,
        total: 0,
      },
      formVisible: false,
      detailVisible: false,
      membersVisible: false,
      currentGroup: null,
    };
  },
  created() {
    this.loadData();
  },
  mounted() {
    this.updateTableMaxHeight();
    window.addEventListener("resize", this.updateTableMaxHeight);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateTableMaxHeight);
  },
  methods: {
    updateTableMaxHeight() {
      this.$nextTick(() => {
        const tableEl = this.$el && this.$el.querySelector(".el-table");
        if (!tableEl) return;

        const top = tableEl.getBoundingClientRect().top;
        const bottomReserve = 24;
        const minHeight = 240;
        this.tableMaxHeight = Math.max(
          minHeight,
          Math.floor(window.innerHeight - top - bottomReserve),
        );
      });
    },
    async loadData() {
      this.loading = true;
      try {
        const params = {
          ...this.searchForm,
          page: this.pagination.page,
          size: this.pagination.size,
        };
        const response = await getGroupList(params);
        this.tableData = response.data.records || response.data || [];
        this.pagination.total = response.data.total || this.tableData.length;
      } catch (error) {
        console.error("加载数据失败:", error);
        this.$message.error("加载数据失败");
      } finally {
        this.loading = false;
        this.updateTableMaxHeight();
      }
    },

    handleSearch() {
      this.pagination.page = 1;
      this.loadData();
    },

    resetSearch() {
      this.searchForm = {
        keyword: "",
        groupType: null,
        status: null,
      };
      this.pagination.page = 1;
      this.loadData();
    },

    handleCreate() {
      this.currentGroup = null;
      this.formVisible = true;
    },

    handleView(row) {
      this.currentGroup = row;
      this.detailVisible = true;
    },

    handleEdit(row) {
      this.currentGroup = row;
      this.formVisible = true;
    },

    async handleCommand(command, row) {
      switch (command) {
        case "members":
          this.currentGroup = row;
          this.membersVisible = true;
          break;
        case "enable":
        case "disable":
          await this.handleStatusChange(row, command === "enable" ? 0 : 1);
          break;
        case "delete":
          await this.handleDelete(row);
          break;
      }
    },

    async handleStatusChange(row, status) {
      try {
        await this.$confirm(
          `确定要${status === 0 ? "启用" : "禁用"}群组"${row.groupName}"吗？`,
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          },
        );

        await changeGroupStatus(row.id, status);
        this.$message.success("操作成功");
        this.loadData();
      } catch (error) {
        if (error !== "cancel") {
          console.error("状态变更失败:", error);
          this.$message.error("操作失败");
        }
      }
    },

    async handleDelete(row) {
      try {
        await this.$confirm(
          `确定要删除群组"${row.groupName}"吗？此操作不可恢复！`,
          "警告",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          },
        );

        await deleteGroup(row.id);
        this.$message.success("删除成功");
        this.loadData();
      } catch (error) {
        if (error !== "cancel") {
          console.error("删除失败:", error);
          this.$message.error("删除失败");
        }
      }
    },

    handleSelectionChange(selection) {
      this.selectedRows = selection;
    },

    handleSizeChange(size) {
      this.pagination.size = size;
      this.loadData();
    },

    handleCurrentChange(page) {
      this.pagination.page = page;
      this.loadData();
    },

    handleFormSuccess() {
      this.formVisible = false;
      this.loadData();
    },
  },
};
</script>

<style lang="scss" scoped>
.group-info {
  display: flex;
  align-items: center;
}

.pagination {
  margin-top: 20px;
  text-align: center;
}
</style>
